import { useQuery } from '@tanstack/react-query';
import { getStates } from 'services/api/requests/requests';

export const useStateList = () => {
	return useQuery(['state-list'], getStates, {
		refetchOnWindowFocus: false,
	});
};
